export const getUserMenuItemsEndpoint = '/{ptDbId}/me';
